import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Brand } from '../../models/brand.model';
import { BrandService } from '../../services/brand.service';
import { AuthService } from '../../auth/auth.service';
import { ReversePipe } from '../../reverse.pipe';

@Component({
  selector: 'app-selected-brand',
  templateUrl: './selected-brand.component.html',
  styleUrls: ['./selected-brand.component.css']
})
export class SelectedBrandComponent implements OnInit {
brand:Brand;
brands:Brand[];
id:number;
bid:number;
new:boolean;
edit:boolean;
adminauth:boolean;
userauth:boolean;  
admin:boolean; 

  constructor(private brandService:BrandService,private authService:AuthService,private route:ActivatedRoute,private router:Router) { 

  }
  
  ngOnInit() {
    this.route.params.subscribe(
      (params:Params)=>{
        this.id=+params['id'];
        this.brand=this.brandService.getBrand(this.id);
        //console.log(this.brand.phones);
        
        //this.brand=this.brands[this.id]
      }
    );
    if((localStorage.getItem('user')=='FTzCUkaxQxaKmISWlKQQOpo2ZHh2') || (localStorage.getItem('user')=='dH6SQbCzhKYOK7dmIJAgJ5P0Xbx2')){
      this.adminauth=true;
      console.log(this.adminauth);
  }
  else{
      this.userauth=true;
  }
    this.admin=this.authService.adminauth;
    this.admin=this.adminauth;
  }
  
  
  onEditPhone(){
    this.brandService.new=true;
    this.brandService.edit=false;
    this.bid=this.brandService.bid;
    this.router.navigate(['new'],{relativeTo:this.route});
  }

}



// WEBPACK FOOTER //
// G:/phoneinfo2/phoneinfo/src/app/components/selected-brand/selected-brand.component.ts